<div id="mati-button-container" style="visibility: hidden"></div>
<div class="flex flex-column w-full mt-8" *ngIf="status == null">
  <p-progressSpinner class="mb-5 flex"></p-progressSpinner>
  <p class="text-center text-xl">Cargando...</p>
</div>
<div class="flex flex-column w-full mt-8" *ngIf="status == 206">
  <p-progressSpinner class="mb-5 flex"></p-progressSpinner>
  <p class="text-center text-xl">Por favor espere mientras validamos la información</p>
</div>
<div class="flex w-screen justify-content-center" *ngIf="status == 200">
  <div class="flex flex-column w-full sm:w-8 max-w-container p-5">
    <h1 class="bg-gray-500 text-white p-2">Confirmación</h1>
    <p class="text-xl sm:text-2xl mb-4">Verifica si toda tu información personal es correcta. Presiona GUARDAR para confirmar. Si ves errores, presiona CANCELAR</p>
    <div class="grid grid-nogutter mb-4">
      <div class="flex flex-column col-12 md:col-4 lg:col-3 p-3">
        <label class="text-md mb-2">Foto:</label>
        <div class="flex">
          <img [src]="userInformation.selfie_photo_url" alt="Selfie" class="w-17rem md:w-14rem border-round-xl">
        </div>
      </div>
      <div class="grid col-12 md:col-8 lg:col-9 p-3">
        <div class="flex flex-column col-12 md:col-6 p-3">
          <label class="text-md mb-2">Número de identificación:</label>
          <label class="text-3xl border-bottom-1 h-full break-word">{{ userInformation.identification_number }}</label>
        </div>
        <div class="flex flex-column col-12 md:col-6 p-3">
          <label class="text-md mb-2">Nombre:</label>
          <label class="text-3xl border-bottom-1 h-full">{{ userInformation.first_name }}</label>
        </div>
        <div class="flex flex-column col-12 md:col-6 p-3">
          <label class="text-md mb-2">Apellido:</label>
          <label class="text-3xl border-bottom-1 h-full">{{ userInformation.last_name }}</label>
        </div>
        <div class="flex flex-column col-12 md:col-6 p-3">
          <label class="text-md mb-2">Fecha de nacimiento:</label>
          <label class="text-3xl border-bottom-1 h-full">{{ userInformation.date_of_birth | date: 'shortDate'}}</label>
        </div>
        <div class="flex flex-column col-12 p-3">
          <label class="text-md mb-2">Teléfono:</label>
          <label class="text-3xl border-bottom-1 h-full">{{ userInformation.phone }}</label>
        </div>
        <div class="flex flex-column col-12 p-3">
          <label class="text-md mb-2">Correo Electrónico:</label>
          <label class="text-3xl border-bottom-1 h-full break-word">{{ userInformation.email }}</label>
        </div>
      </div>
    </div>
    <div class="flex w-full justify-content-end">
      <button pButton pRipple type="button" label="Cancelar" [loading]="loading" (click)="onDataError()" class="p-button-secondary p-button-lg"></button>
      <button pButton pRipple type="button" label="Guardar" icon="pi pi-send" (click)="confirm()" class="p-button-lg ml-3"></button>
    </div>
  </div>
</div>
